export default "__VITE_ASSET__CyO7JXfP__"